import React from 'react';
import { motion } from 'framer-motion';
import { HiExternalLink } from 'react-icons/hi';

const Projects: React.FC = () => {
  const projects = [
    {
      title: 'Standards Australia Website',
      description: 'Official online store for Standards Australia, providing access to Australian Standards and publications.',
      image: 'https://via.placeholder.com/400x250/3B82F6/FFFFFF?text=Standards+Australia',
      technologies: ['.NET', 'React', 'Azure', 'E-commerce'],
      liveUrl: 'https://store.standards.org.au/',
      githubUrl: '',
      featured: true
    },
    {
      title: 'Hummgroup Merchant Portal',
      description: 'Merchant portal for Hummgroup, enabling sellers to manage their accounts, transactions, and reporting.',
      image: 'https://via.placeholder.com/400x250/10B981/FFFFFF?text=Hummgroup+Merchant+Portal',
      technologies: ['.NET Core', 'Aurelia', 'Angular', 'RabbitMQ', 'Oracle', 'Octopus Deploy'],
      liveUrl: 'https://seller.shophumm.com.au/',
      githubUrl: '',
      featured: true
    },
    {
      title: 'Hummgroup Buyer Portal',
      description: 'Buyer portal for Hummgroup, providing customers with a seamless shopping and financing experience.',
      image: 'https://via.placeholder.com/400x250/F59E0B/FFFFFF?text=Hummgroup+Buyer+Portal',
      technologies: ['.NET Core', 'Aurelia', 'Angular', 'RabbitMQ', 'Oracle', 'Octopus Deploy'],
      liveUrl: 'https://buyer.shophumm.com.au/',
      githubUrl: '',
      featured: true
    }
  ];

  return (
    <section id="projects" className="section-padding bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-dark-900 mb-4">Featured Projects</h2>
          <p className="text-lg text-dark-600 max-w-2xl mx-auto">
            A showcase of my recent work and the technologies I've used to bring ideas to life
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`bg-white rounded-xl overflow-hidden shadow-lg card-hover ${
                project.featured ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              {/* Project Content Only (no image) */}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-dark-900 mb-3">
                  {project.title}
                </h3>
                <p className="text-dark-600 mb-4 leading-relaxed">
                  {project.description}
                </p>

                {/* Technologies */}
                <div className="mb-4">
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, techIndex) => (
                      <span
                        key={techIndex}
                        className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Project Links */}
                <div className="flex gap-3">
                  <a
                    href={project.liveUrl}
                    className="flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors duration-200"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <HiExternalLink size={16} />
                    Live Demo
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* View More Projects Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <button className="btn-secondary">
            View All Projects
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects; 